// Mirrors src/entitlements/tiers.ts — single source of truth for entitlement keys.
// Keep ADDON_MODULES and RMS_TIERS in sync with the backend file.

export const RMS_TIERS = ['free', 'standard', 'premium'] as const;
export type RmsTier = (typeof RMS_TIERS)[number];

export const ADDON_MODULES = ['ai_diagnostics', 'advanced_telemetry'] as const;
export type AddonModule = (typeof ADDON_MODULES)[number];

// Classroom (education product line) — separate from the RMS tier hierarchy
export const CLASSROOM_MODULES = ['classroom'] as const;
export type ClassroomModule = (typeof CLASSROOM_MODULES)[number];
export const CLASSROOM_TIERS = ['base'] as const;
export type ClassroomTier = (typeof CLASSROOM_TIERS)[number];

export interface EntitlementOption {
  module: string;
  tier: string;
}

export const ENTITLEMENT_OPTIONS: EntitlementOption[] = [
  ...ADDON_MODULES.flatMap((m) => RMS_TIERS.map((t) => ({ module: m, tier: t }))),
  ...CLASSROOM_MODULES.flatMap((m) => CLASSROOM_TIERS.map((t) => ({ module: m, tier: t }))),
];
